import {
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import React, { CSSProperties } from "react";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";

const IMAGE_SERVER = process.env.REACT_APP_IMAGES_ENDPOINT;

interface IProps {
  image: string;
  cssImage: CSSProperties;
  deleteFieldImage: () => void;
  height?: string;
};

export const PreviewImage: React.FC<IProps> = ({ image, cssImage, height, deleteFieldImage }) => {

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#f6f6f6",
        borderRadius: 1.5,
        height,
        display: "flex", // Flexbox para alinear elementos
        justifyContent: "center", // Centrar horizontalmente
        alignItems: "center", // Centrar verticalmente
      }}
    >
      {/* Imagen */}
      <img
        src={`${IMAGE_SERVER}/${image}`}
        alt="upload"
        style={cssImage}
      />

      {/* Botón de eliminar */}
      <IconButton
        onClick={() => {
          deleteFieldImage();
        }}
        sx={{
          position: "absolute",
          right: "1rem", // Ajusta la posición a la derecha
          top: "50%",
          transform: "translateY(-50%)", // Centra verticalmente el botón
        }}
      >
        <DeleteIcon />
      </IconButton>
    </Box>
  );
};
